// extracted by mini-css-extract-plugin
export var chevron = "_mc-4";
export var chevronExpanded = "_mc-5";
export var row = "_mc-0";
export var rowBody = "_mc-6";
export var rowDescription = "_mc-7";
export var rowHeader = "_mc-1";
export var rowTitle = "_mc-2";
export var rowTitleComplete = "_mc-3";